import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../../css';

function ACIcon(props) {
  const { height, width, iconColor } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.96 14.35" height={height} width={width}>
      <g id="Layer_2" data-name="Layer 2">
        <g className="cls-1" id="Layer_1-2" data-name="Layer 1">
          <polygon
            fill={iconColor}
            points="2.52 2.33 12.98 2.33 11.5 1.73 10.81 0.84 9.55 0.44 8.72 0.68 6.95 0 6.35 1.13 4.93 0.8 3.15 0.97 2.52 2.33"
          />
          <circle fill={iconColor} cx="7.33" cy="11.24" r="3.11" />
          <circle fill={iconColor} cx="17.08" cy="11.24" r="3.11" />
          <path
            fill={iconColor}
            d="M19.87,6.12l-1-2h1.48V1.58H14.46L13.19,2.84H2.37L0,5.33l5.28,1.9v1A3.64,3.64,0,0,1,11,11h2.46a3.65,3.65,0,0,1,7.29,0H22V6.12Zm-16.63-1H2.39L3.56,4h.85Zm2.55,0H4.94L6.12,4H7Zm2.57,0H7.51L8.69,4h.84Zm2.56,0h-.84L11.25,4h.85Zm4.44,1V4.51H17.3l.76,1.6Z"
          />
        </g>
      </g>
    </svg>
  );
}

ACIcon.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconColor: PropTypes.string
};

ACIcon.defaultProps = {
  width: 22,
  height: undefined,
  iconColor: colors.colorGrey06
};

export default ACIcon;
